import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Truck, Settings, Box, BarChart2, Brain, User, Layers, Globe, TrendingUp } from 'lucide-react';

const services = [
  {
    title: 'Gestão de Transporte e Frete',
    description: 'Redução de custos e negociação estratégica para otimizar sua operação de transportes.',
    icon: Truck,
    slug: 'gestao-de-transporte-e-frete',
  },
  {
    title: 'Roteirização Inteligente',
    description: 'Uso de IA para otimizar rotas de entrega e reduzir custos operacionais.',
    icon: Settings,
    slug: 'roteirizacao-inteligente',
  },
  {
    title: 'Gestão de Estoques',
    description: 'Estratégias para evitar rupturas e excessos em seus centros de distribuição.',
    icon: Box,
    slug: 'gestao-de-estoques',
  },
  {
    title: 'Análise de Custos Logísticos',
    description: 'Identificação e implementação de estratégias para redução de despesas.',
    icon: BarChart2,
    slug: 'analise-de-custos-logisticos',
  },
  {
    title: 'Tecnologia e IA na Logística',
    description: 'Aplicação de machine learning para previsibilidade e otimização.',
    icon: Brain,
    slug: 'tecnologia-e-ia-na-logistica',
  },
  {
    title: 'Consultoria Personalizada',
    description: 'Soluções customizadas para as necessidades específicas do seu negócio.',
    icon: User,
    slug: 'consultoria-personalizada',
  },
  {
    title: 'Inventário',
    description: 'Gestão eficiente de inventário para minimizar custos e maximizar a disponibilidade.',
    icon: Layers,
    slug: 'inventario',
  },
  {
    title: 'Comércio Exterior',
    description: 'Soluções logísticas completas para importação e exportação.',
    icon: Globe,
    slug: 'comercio-exterior',
  },
  {
    title: 'Expansão de Negócios',
    description: 'Estratégias e suporte logístico para a expansão de suas operações.',
    icon: TrendingUp,
    slug: 'expansao-de-negocios',
  },
];

export default function Services({ showTitle = true }: { showTitle?: boolean }) {
  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {showTitle && (
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Nossos Serviços</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Oferecemos soluções completas em logística e supply chain para otimizar suas operações
              e impulsionar seus resultados.
            </p>
          </div>
        )}
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.08 }}
              className="relative"
            >
              <Link
                to={`/servicos/${service.slug}`}
                className="block group"
              >
                <div className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-blue-600 text-white">
                    <service.icon className="h-6 w-6" aria-hidden="true" />
                  </div>
                  <h3 className="mt-4 text-xl font-bold text-gray-900 group-hover:text-blue-600">
                    {service.title}
                  </h3>
                  <p className="mt-4 text-gray-500">
                    {service.description}
                  </p>
                  <div className="mt-6 flex items-center text-blue-600 group-hover:text-blue-500">
                    <span className="text-sm font-medium">Saiba mais</span>
                    <svg className="ml-2 h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}